import React, { useState } from 'react';
import {
  CANAL_TIENDA_ACTORS,
  stateLabel,
  stateColor
} from '../constants/ecosystemProjects';
import './EcosystemPanels.css';

const PRIORITY_LABEL = { alta: 'Alta', media: 'Media', baja: 'Baja' };
const CANAL_TASKS_KEY = 'javiland_canal_tienda_tasks';

const loadDoneTasks = () => {
  try {
    const raw = localStorage.getItem(CANAL_TASKS_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

const CanalTiendaPanel = ({ onNavigate }) => {
  const [doneTasks, setDoneTasks] = useState(loadDoneTasks);

  const toggleTask = (id) => {
    setDoneTasks((prev) => {
      const next = { ...prev, [id]: !prev[id] };
      try {
        localStorage.setItem(CANAL_TASKS_KEY, JSON.stringify(next));
      } catch {
        /* ignore */
      }
      return next;
    });
  };

  const followUps = CANAL_TIENDA_ACTORS.filter((a) => a.followUp);

  return (
    <div className="eco-panel">
      <header className="eco-panel-header">
        <h2>Canal tienda y proveedores</h2>
        <p>SKUs, dropshipping y alianzas que alimentan javiland.com — Annita solo aquí, no en Cotizaciones.</p>
      </header>

      {followUps.length > 0 ? (
        <section className="eco-followup-box" aria-label="Seguimiento comercial">
          <h3>
            <i className="fas fa-bell" aria-hidden /> Seguimiento pendiente
          </h3>
          <ul className="eco-followup-list">
            {followUps.map((a) => (
              <li key={`fu-${a.id}`}>
                <label>
                  <input
                    type="checkbox"
                    checked={!!doneTasks[a.id]}
                    onChange={() => toggleTask(a.id)}
                  />
                  <span>
                    <strong>{a.name}:</strong> {a.followUpHint || a.blocker}
                  </span>
                </label>
              </li>
            ))}
          </ul>
          <p className="eco-followup-note">
            También puedes dar seguimiento por WhatsApp; esto es recordatorio en el panel.
          </p>
        </section>
      ) : null}

      <div className="eco-table-wrap">
        <table className="eco-table">
          <thead>
            <tr>
              <th>Actor</th>
              <th>Estado canal</th>
              <th>Prioridad</th>
              <th>Bloqueador</th>
              <th>Próximo paso</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {CANAL_TIENDA_ACTORS.map((row) => (
              <tr key={row.id}>
                <td>
                  <strong>{row.name}</strong>
                  {row.doc ? (
                    <div className="eco-table-doc" title={row.doc}>
                      {row.doc}
                    </div>
                  ) : null}
                </td>
                <td>
                  <span
                    className="eco-state-pill eco-state-pill--sm"
                    style={{ backgroundColor: stateColor(row.canalState), color: '#fff' }}
                  >
                    {stateLabel(row.canalState)}
                  </span>
                </td>
                <td>{PRIORITY_LABEL[row.priority] || row.priority}</td>
                <td>{row.blocker || '—'}</td>
                <td>{row.nextStep || '—'}</td>
                <td>
                  {row.id === 'himalaya' && typeof onNavigate === 'function' ? (
                    <button
                      type="button"
                      className="eco-link-btn"
                      onClick={() => onNavigate('orders', 'dropshipping')}
                    >
                      Cola dropship
                    </button>
                  ) : row.id === 'kaaba' || row.id === 'jdn' || row.id === 'nutrisetas' ? (
                    <button
                      type="button"
                      className="eco-link-btn"
                      onClick={() => onNavigate('products', '')}
                    >
                      Productos
                    </button>
                  ) : null}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CanalTiendaPanel;
